// Single source of truth for clinic locations.
// Every section (Header, Hero, Clinics, Contact, Footer, WhatsApp CTAs) reads from here,
// so adding or editing a clinic is a data change only.

export const CLINICS = [
  {
    id: "denpasar",
    name: "Marvie Beauty Denpasar",
    area: "Denpasar",
    address: "Jl. Gunung Soputan I No.83, Pemecutan Klod, Denpasar Barat, Bali 80119",
    hours: { days: "Mon – Sat", time: "10:00 – 19:00", closed: "Sunday" },
    whatsapp: "6287729138734",
    phoneDisplay: "+62 877-2913-8734",
    mapsUrl: "https://maps.app.goo.gl/esYAdbyqnEeoq3wj7",
    mapEmbedUrl:
      "https://www.google.com/maps/embed?pb=!1m12!1m8!1m3!1d3944.0584879103712!2d115.1878251!3d-8.6859773!3m2!1i1024!2i768!4f13.1!2m1!1sMarvie+Beauty!6i17",
    photos: [
      { src: "/assets/clinics/denpasar-1.webp", alt: "Treatment room at Marvie Beauty Denpasar" },
      { src: "/assets/hero-slide-3.webp", alt: "Facial treatment at Marvie Beauty Denpasar" },
      { src: "/assets/gallery-4.webp", alt: "Client at Marvie Beauty Denpasar" },
    ],
    isNew: false,
  },
  {
    id: "sesetan",
    name: "Marvie Beauty Sesetan",
    area: "Sesetan",
    address: "Ruko Maja, Jl. Tegal Wangi No.C3, Sesetan, Denpasar Selatan, Bali 80225",
    hours: { days: "Mon – Sat", time: "10:00 – 19:00", closed: "Sunday" },
    // Shares the main WhatsApp line for now
    whatsapp: "6287729138734",
    phoneDisplay: "+62 877-2913-8734",
    mapsUrl: "https://maps.app.goo.gl/uPE7J7eD44sGfbnz9",
    mapEmbedUrl:
      "https://www.google.com/maps/embed?pb=!1m12!1m8!1m3!1d3944.0143731578373!2d115.2211423!3d-8.6901712!3m2!1i1024!2i768!4f13.1!2m1!1sMarvie+Beauty+Sesetan!6i17",
    photos: [
      { src: "/assets/clinics/sesetan-1.webp", alt: "Facial treatment room at Marvie Beauty Sesetan" },
      { src: "/assets/clinics/sesetan-2.webp", alt: "Treatment room with gold wall lights at Marvie Beauty Sesetan" },
      { src: "/assets/clinics/sesetan-3.webp", alt: "Bright treatment room at Marvie Beauty Sesetan" },
      { src: "/assets/clinics/sesetan-4.webp", alt: "Doctor's consultation corner at Marvie Beauty Sesetan" },
      { src: "/assets/clinics/sesetan-5.webp", alt: "Treatment bed and lamp at Marvie Beauty Sesetan" },
      { src: "/assets/clinics/sesetan-6.webp", alt: "Private treatment room at Marvie Beauty Sesetan" },
      { src: "/assets/clinics/sesetan-7.webp", alt: "Treatment chair at Marvie Beauty Sesetan" },
      { src: "/assets/clinics/sesetan-storefront.webp", alt: "Marvie Beauty Sesetan storefront at Ruko Maja, Jl. Tegal Wangi" },
    ],
    isNew: true,
  },
];

export const getClinic = (id) => CLINICS.find((c) => c.id === id) ?? CLINICS[0];

export const whatsappUrl = (clinic, text) =>
  `https://wa.me/${clinic.whatsapp}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const formatHours = (clinic) =>
  `${clinic.hours.days}, ${clinic.hours.time}${clinic.hours.closed ? ` · Closed ${clinic.hours.closed}` : ""}`;

// Default prefilled message for general "Book" CTAs
export const consultMessage = (clinic) => `Halo ${clinic.name}, saya ingin konsultasi`;

export const SAME_PRICE_NOTE = `Same prices at ${CLINICS.length === 2 ? "both" : "all"} clinics`;
